import { render, staticRenderFns } from "./Anamnese.vue?vue&type=template&id=68a08801&"
import script from "./Anamnese.vue?vue&type=script&lang=js&"
export * from "./Anamnese.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports